import { dispatchEvent } from '../../utils';
import { isImmutable } from 'immutable';
import { pick, merge, isEmpty, is } from 'ramda';
import {contextualizeAppConfig} from '@synergycms_core/store/app/utils';

const mappings = {
  search: {
    path: ['customer', 'params', 'url_params']
  },
  hotels: {
    path: 'hotels'
  },
  avail: {
    path: 'avail'
  },
  availServices: {
    path: 'availServices'
  },
  query_params: {
    name: 'params',
    path: store => {
      const hotelId = store.getIn(['customer', 'current_hotel']);
      return ['hotels', hotelId, 'params', 'params'];
    }
  },
  reservation: {
    path: ['customer', 'reservation']
  },
  current_currency: {
    name: 'currentCurrency',
    path: ['customer', 'current_currency']
  },
  reservation_request: {
    name: 'reservation',
    path: ['customer', 'reservation_request']
  },
  hotel: {
    path: store => {
      const hotelId = store.getIn(['customer', 'current_hotel']);
      return ['hotels', hotelId];
    }
  }
};

const storeRetriever = store => fields => {
  let result = {};
  fields.forEach(field => {
    if (mappings[field]) {
      const fieldData = mappings[field];
      const fieldPath = is(Function, fieldData.path) ? fieldData.path(store) : fieldData.path;
      const fieldName = fieldData.name || field;
      const fieldValue = is(Array, fieldPath) ? store.getIn(fieldPath) : store.get(fieldPath);

      result = merge(
        {
          [fieldName]: isImmutable(fieldValue) ? fieldValue.toJS() : fieldValue
        },
        result
      );
    }
  });

  return result;
};

const getOccupancies = occupancies => {
  let adults = 0;
  let childs = 0;

  const [...keys] = occupancies.keys();
  keys.forEach(key => {
    if (occupancies.get(key).has('adults')) {
      adults += occupancies.getIn([key, 'adults']);
    }

    if (occupancies.get(key).has('childs')) {
      childs += occupancies.getIn([key, 'childs']);
    }
  });

  return {
    adults,
    childs
  };
};

export default {
  TRIGGER: (name, additionalData = {}) => (dispatch, getState) => {
    const store = getState();
    let data = {};
    let fields = [];

    switch (name) {
      case 'add_filter_stars':
      case 'del_filter_stars':
        fields = ['current_currency'];
        data = {
          filter: {
            stars: +additionalData.code.replace(/\D/g, '')
          }
        };

        break;
      case 'add_filter_prices':
      case 'del_filter_prices':
        const code = additionalData.code.replace('<', 0).replace('>', 99999);
        const [min, max] = code.match(/(\d+)/g);
        fields = ['current_currency'];
        data = {
          filter: { min, max }
        };

        break;
      case 'show_avail':
        const step = store.getIn(['customer', 'step', 'current_step', 'code']);
        fields = ['search'];
        if (step === 'multiHotelAvail' || step === 'monoHotelAvail') {
          Array.prototype.push.apply(fields, ['hotels', 'avail', 'availServices', 'current_currency']);

          // For 'show_avail_price_as' at datalayer
          const langInfo = store.getIn(['customer', 'lang_info', 'code']);
          const hotelId = store.getIn(['customer', 'current_hotel']);
          const hotelConfig = contextualizeAppConfig(store, hotelId);

          // For 'avail_time' at datalayer 
          const queryParams = store.getIn(['hotels', hotelId, 'params', 'query_params']);
          const loyaltyQueryParams = store.getIn(['hotels', hotelId, 'params', 'loyalty_query_params']);

          const availTime = store.getIn(['avail', hotelId, queryParams, 'request_duration'], false);
          const availTimeloyalty = store.getIn(['avail', hotelId, loyaltyQueryParams, 'request_duration'], false);
          
          data = {
            availQueryType: store.getIn([
              "availQuery", 
              step === 'multiHotelAvail' ? 'multi' : 'mono', 
              step === 'multiHotelAvail' ? "base_query_params" : "query_params"
            ]),
            availType: step === 'multiHotelAvail' ? 'multi' : 'mono',
            hotelConfig: hotelConfig,
            langInfo: langInfo,
            availTime: availTime,
            availTimeloyalty: availTimeloyalty,
          };
        }

        break;
      case 'multiavail_book':
        const searchParams = store.getIn(['customer', 'params', 'url_params']);

        fields = ['hotel', 'current_currency'];
        data = {
          reservation: merge(
            {
              start: searchParams.get('start'),
              end: searchParams.get('end')
            },
            getOccupancies(searchParams.get('occups')),
            pick(['hotelCode', 'bestPriceTax'], additionalData)
          )
        };

        break;
      case 'add_room':
      case 'del_room':
        data = pick(['room'], additionalData);
        fields = ['hotel', 'reservation_request', 'query_params', 'current_currency'];

        break;
      case 'add_service':
      case 'del_service':
        data = pick(['service', 'count'], additionalData);
        fields = ['hotel', 'reservation_request', 'current_currency'];

        break;
      case 'add_filter':
      case 'del_filter':
        data = pick(['filters', 'filteredHotels'], additionalData);
        fields = ['hotels', 'current_currency'];

        break;
      case 'next_step_1':
      case 'next_step_2':
        fields = ['hotel', 'reservation_request', 'current_currency'];

        break;
      case 'customer_data':
      case 'confirm_customer_data':
      case 'confirmed_booking':
        fields = ['hotel', 'reservation', 'current_currency'];

        break;
      case 'confirm_error':
        fields = ['hotel', 'reservation', 'current_currency'];
        data = pick(['error'], additionalData);

        break;
      case 'cancelled_booking':
        fields = ['hotel', 'reservation', 'current_currency'];

        break;
      case 'payment':
        data = pick(['hasStoredCards', 'newSelectedPayform', 'pciFrameLoaded'],additionalData);
        break;
      case 'form_email':
        data = pick(['email'], additionalData);
        break;
      default:
        data = {};
    }



    if (!isEmpty(fields)) {
      data = merge(storeRetriever(store)(fields), data);
    }

    if (!isEmpty(data)) {
      dispatchEvent(name, data);
    }
  }
};
